/**
 * DO NOT CHANGE THIS FILE.
 *
 *  This file was auto generated by the following command:
 *    `bin/generate-feature-definitions.sh`
 */

export enum AvailableModules {
  accounts_payable = 'accounts_payable',
  analytics = 'analytics',
  ats = 'ats',
  benefits = 'benefits',
  communities = 'communities',
  compensations = 'compensations',
  competencies = 'competencies',
  complaints = 'complaints',
  contracts = 'contracts',
  documents = 'documents',
  engagement = 'engagement',
  engagement_insights = 'engagement_insights',
  enps = 'enps',
  expenses = 'expenses',
  finance = 'finance',
  goals = 'goals',
  it_management = 'it_management',
  it_management_v2 = 'it_management_v2',
  lms = 'lms',
  marketplace = 'marketplace',
  one = 'one',
  payroll = 'payroll',
  processes = 'processes',
  procurement = 'procurement',
  projects = 'projects',
  review_process = 'review_process',
  salary_advance = 'salary_advance',
  sales = 'sales',
  shift_management = 'shift_management',
  space_control = 'space_control',
  surveys = 'surveys',
  time_balance = 'time_balance',
  time_tracking = 'time_tracking',
  timeoff = 'timeoff',
  trainings = 'trainings',
}

export enum Features {
  accounts_payable_management = 'accounts_payable_management',
  accounts_payable_payments = 'accounts_payable_payments',
  accounts_payable_accounting = 'accounts_payable_accounting',
  analytics_advanced_reports = 'analytics_advanced_reports',
  ats_management = 'ats_management',
  ats_message_templates = 'ats_message_templates',
  ats_customized_features = 'ats_customized_features',
  ats_insights = 'ats_insights',
  ats_job_requisitions = 'ats_job_requisitions',
  ats_evaluation_forms = 'ats_evaluation_forms',
  ats_career_page_customization = 'ats_career_page_customization',
  ats_interview_scheduling = 'ats_interview_scheduling',
  ats_smart_actions = 'ats_smart_actions',
  ats_ai_top_match = 'ats_ai_top_match',
  ats_vonq = 'ats_vonq',
  ats_active_jobs = 'ats_active_jobs',
  benefits_core = 'benefits_core',
  benefits_core_pt = 'benefits_core_pt',
  benefits_healthcare = 'benefits_healthcare',
  benefits_trainings = 'benefits_trainings',
  benefits_wellness = 'benefits_wellness',
  benefits_perks = 'benefits_perks',
  communities_core = 'communities_core',
  communities_claps = 'communities_claps',
  compensations_management = 'compensations_management',
  competencies_core = 'competencies_core',
  complaints_core = 'complaints_core',
  contracts_discontinuous_contracts = 'contracts_discontinuous_contracts',
  documents_templates = 'documents_templates',
  engagement_employee_pulse_questions = 'engagement_employee_pulse_questions',
  engagement_pulse_ai_report = 'engagement_pulse_ai_report',
  engagement_one_on_one_meetings = 'engagement_one_on_one_meetings',
  engagement_pages = 'engagement_pages',
  engagement_insights_core = 'engagement_insights_core',
  enps_core = 'enps_core',
  expenses_core = 'expenses_core',
  expenses_auto_approval_rules = 'expenses_auto_approval_rules',
  expenses_aeat = 'expenses_aeat',
  expenses_homologation = 'expenses_homologation',
  expenses_form_customization = 'expenses_form_customization',
  expenses_approval_policies = 'expenses_approval_policies',
  expenses_multiapprovers_per_level = 'expenses_multiapprovers_per_level',
  expenses_reimburse_through_payroll = 'expenses_reimburse_through_payroll',
  expenses_reimburse_through_payments = 'expenses_reimburse_through_payments',
  expenses_physical_cards = 'expenses_physical_cards',
  expenses_card_limits = 'expenses_card_limits',
  expenses_monthly_managed_expenses = 'expenses_monthly_managed_expenses',
  expenses_cards_management = 'expenses_cards_management',
  expenses_report_on_behalf = 'expenses_report_on_behalf',
  expenses_accounting_accounts = 'expenses_accounting_accounts',
  expenses_expensable_groups = 'expenses_expensable_groups',
  expenses_per_user_pricing_create_expenses = 'expenses_per_user_pricing_create_expenses',
  expenses_spending_policies = 'expenses_spending_policies',
  expenses_per_diems = 'expenses_per_diems',
  expenses_physical_card = 'expenses_physical_card',
  finance_cost_center_management = 'finance_cost_center_management',
  finance_workspace = 'finance_workspace',
  finance_workspace_cost_centers_dimension = 'finance_workspace_cost_centers_dimension',
  finance_workspace_multicurrency = 'finance_workspace_multicurrency',
  finance_custom_dimensions = 'finance_custom_dimensions',
  finance_payments_core = 'finance_payments_core',
  finance_ledger_accounts_core = 'finance_ledger_accounts_core',
  finance_purchase_financial_documents_core = 'finance_purchase_financial_documents_core',
  goals_v2_core = 'goals_v2_core',
  it_management_management = 'it_management_management',
  it_management_v2_core = 'it_management_v2_core',
  lms_core = 'lms_core',
  marketplace_a3innuva_integration = 'marketplace_a3innuva_integration',
  marketplace_oracle_netsuite_integration = 'marketplace_oracle_netsuite_integration',
  marketplace_datev_factorial_integration = 'marketplace_datev_factorial_integration',
  marketplace_business_central_integration = 'marketplace_business_central_integration',
  marketplace_silae_fortify_integration = 'marketplace_silae_fortify_integration',
  marketplace_sage200_gmintegra_integration = 'marketplace_sage200_gmintegra_integration',
  marketplace_milena_illusion_integration = 'marketplace_milena_illusion_integration',
  marketplace_suprema_xiptic_integration = 'marketplace_suprema_xiptic_integration',
  marketplace_zkteco_zkteco_integration = 'marketplace_zkteco_zkteco_integration',
  one_core = 'one_core',
  one_beta = 'one_beta',
  payroll_management = 'payroll_management',
  processes_custom_email_action = 'processes_custom_email_action',
  procurement_core = 'procurement_core',
  procurement_purchase_requests = 'procurement_purchase_requests',
  procurement_purchase_orders = 'procurement_purchase_orders',
  procurement_approval_smart_rules = 'procurement_approval_smart_rules',
  projects_management = 'projects_management',
  projects_with_subprojects = 'projects_with_subprojects',
  projects_flexible_tracking = 'projects_flexible_tracking',
  projects_import = 'projects_import',
  projects_overview = 'projects_overview',
  projects_budget = 'projects_budget',
  projects_costs = 'projects_costs',
  projects_bulk_actions = 'projects_bulk_actions',
  projects_logs = 'projects_logs',
  projects_tasks = 'projects_tasks',
  projects_clients = 'projects_clients',
  projects_contributors = 'projects_contributors',
  projects_v2_0 = 'projects_v2_0',
  projects_planning = 'projects_planning',
  projects_core = 'projects_core',
  review_process_core = 'review_process_core',
  review_process_custom_score_configuration = 'review_process_custom_score_configuration',
  salary_advance_core = 'salary_advance_core',
  sales_core = 'sales_core',
  sales_deals = 'sales_deals',
  sales_quotes_management = 'sales_quotes_management',
  sales_invoices_management = 'sales_invoices_management',
  sales_invoices_creation = 'sales_invoices_creation',
  sales_accounting = 'sales_accounting',
  shift_management_management = 'shift_management_management',
  shift_management_coverage_view = 'shift_management_coverage_view',
  shift_management_copy_schedule_period = 'shift_management_copy_schedule_period',
  shift_management_insights_panel = 'shift_management_insights_panel',
  shift_management_view_options = 'shift_management_view_options',
  shift_management_swap_shifts = 'shift_management_swap_shifts',
  shift_management_save_shift_toggle = 'shift_management_save_shift_toggle',
  shift_management_automatic_planning = 'shift_management_automatic_planning',
  space_control_spaces = 'space_control_spaces',
  surveys_core = 'surveys_core',
  time_balance_management = 'time_balance_management',
  time_balance_annualisation_export = 'time_balance_annualisation_export',
  time_tracking_management = 'time_tracking_management',
  time_tracking_multi_policies = 'time_tracking_multi_policies',
  time_tracking_automatic_breaks = 'time_tracking_automatic_breaks',
  time_tracking_overtime_requests = 'time_tracking_overtime_requests',
  time_tracking_time_ranges = 'time_tracking_time_ranges',
  time_tracking_ranges_and_tolerances = 'time_tracking_ranges_and_tolerances',
  time_tracking_face_recognition = 'time_tracking_face_recognition',
  time_tracking_geofencing_alerts = 'time_tracking_geofencing_alerts',
  time_tracking_autofill_timesheet = 'time_tracking_autofill_timesheet',
  time_tracking_edit_timesheet_authorization = 'time_tracking_edit_timesheet_authorization',
  time_tracking_real_time_attendance = 'time_tracking_real_time_attendance',
  time_tracking_time_alerts = 'time_tracking_time_alerts',
  time_tracking_automatic_planned_breaks = 'time_tracking_automatic_planned_breaks',
  time_tracking_annualisation_daily_value = 'time_tracking_annualisation_daily_value',
  time_tracking_special_hours_brazil = 'time_tracking_special_hours_brazil',
  time_tracking_corrective_breaks = 'time_tracking_corrective_breaks',
  timeoff_management = 'timeoff_management',
  timeoff_absence_duration_control = 'timeoff_absence_duration_control',
  timeoff_accrual_frequency_options = 'timeoff_accrual_frequency_options',
  timeoff_allowance_negative_counter = 'timeoff_allowance_negative_counter',
  timeoff_allowance_proration = 'timeoff_allowance_proration',
  timeoff_approvals_multilevel = 'timeoff_approvals_multilevel',
  timeoff_blocked_periods = 'timeoff_blocked_periods',
  timeoff_flexible_cycles = 'timeoff_flexible_cycles',
  timeoff_manual_adjustment_options = 'timeoff_manual_adjustment_options',
  timeoff_overtime_compensation = 'timeoff_overtime_compensation',
  timeoff_prorated_tenure_periods = 'timeoff_prorated_tenure_periods',
  timeoff_restricted_leave_types = 'timeoff_restricted_leave_types',
  timeoff_french_jnt_counters = 'timeoff_french_jnt_counters',
  timeoff_french_ouvres = 'timeoff_french_ouvres',
  timeoff_count_bank_holidays = 'timeoff_count_bank_holidays',
  timeoff_leaves_approval_recommendation = 'timeoff_leaves_approval_recommendation',
  trainings_core = 'trainings_core',
}
